export const b64ToBlob = (b64) => fetch(b64).then(res => res.blob());

export const extractMimeTypeFromB64 = (b64) => b64.match(/[^:]\w+\/[\w-+\d.]+(?=;|,)/)[0];

export const extractExtensionFromB64 = (b64) => b64.match(/[^:/]\w+(?=;|,)/)[0];